import * as React from 'react';
import { FieldError, useFormContext } from 'react-hook-form';
// styles
import cn from 'classnames/bind';
import styles from './field.module.css';
// assets
import ResetIcon from './reset.inline.svg';
import LetterIcon from './letter.inline.svg';

const cx = cn.bind(styles);

export interface InputFieldProps {
  disabled?: boolean;
  name: string;
  label?: string;
  placeholder?: string;
  type?: string;
  icon?: React.ReactElement | 'mail';
  resetValue?: () => void;
  validate?: (value: string) => string;
  colorMode?: 'light' | 'dark' | 'white';
  containerClassName?: string;
  error?: FieldError;
}

function InputField({
  disabled,
  name,
  label,
  placeholder,
  icon,
  resetValue,
  colorMode = 'light',
  type = 'text',
  containerClassName,
  error,
}: InputFieldProps) {
  const { register, watch } = useFormContext();
  return (
    <div className={cx('container', colorMode, containerClassName, { error })}>
      {label && (
        <label htmlFor={name} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.fieldWrapper}>
        <div className={cx('inputWrapper', { withIcon: !!icon })}>
          {icon === 'mail' ? <LetterIcon /> : icon}
          <input
            {...register(name)}
            disabled={disabled}
            type={type}
            placeholder={placeholder}
            className={cx('field', 'input') + ' ym-record-keys'}
            id={name}
          />
          {resetValue && (
            <button
              type="button"
              className={cx('resetButton', { notEmpty: watch(name) })}
              onClick={resetValue}
            >
              <ResetIcon />
            </button>
          )}
        </div>
      </div>
      <div className={cx('errorText', { visible: !!error?.message })}>{error?.message}</div>
    </div>
  );
}

export default InputField;
